module.exports = new __parcel__URL__("benefits_4.eb6c766b.webp").toString();